import React from 'react';
import TextSizeControl from './TextSizeControl';
import { Link } from 'react-router-dom';
import './Navigation.css';
import './TextSizeControl.css';

function Navigation({ currentPage, textSize, onTextSizeChange }) {
  return (
    <nav className="header" role="navigation" aria-label="Main navigation">
      <div className="nav-left">
        <a 
          href="https://www.metmuseum.org" 
          target="_blank" 
          rel="noopener noreferrer"
          className="nav-item external-link"
          aria-label="Visit The Met Museum website (opens in new tab)"
        >
          THE MET MUSEUM
        </a>
      </div>
      <div className="nav-center">
        <Link 
          to="/" 
          className={`nav-item title ${currentPage === 'home' ? 'active' : ''}`}
          aria-current={currentPage === 'home' ? 'page' : undefined}
          aria-label="Artwork Gallery - Home page"
        >
          ARTWORK GALLERY
        </Link>
      </div>
      <div className="nav-right">
        <Link 
          to="/my-exhibits" 
          className={`nav-item ${currentPage === 'my-exhibits' ? 'active' : ''}`}
          aria-current={currentPage === 'my-exhibits' ? 'page' : undefined}
          aria-label="My Exhibits page"
        >
          MY EXHIBITS
        </Link>
        <TextSizeControl 
          textSize={textSize}
          onTextSizeChange={onTextSizeChange}
        />
      </div>
    </nav>
  );
}

export default Navigation;
